import { render } from "./TutorialHelp.vue?vue&type=template&id=3286aa14"
import script from "./TutorialHelp.vue?vue&type=script&lang=js"
export * from "./TutorialHelp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__